import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIResponse } from '@/types/generate-ai';
import type { VisionAIGenerateFormData } from './vision-ai-generate.schema';

interface UseGenerateVisionOptions {
  tenantId: string;
}

export const useGenerateVision = ({ tenantId }: UseGenerateVisionOptions) => {
  return useMutation<GenerateAIResponse, Error, VisionAIGenerateFormData>({
    mutationFn: async (data: VisionAIGenerateFormData) => {
      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-vision`,
          data,
        );
        return response.data;
      } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to generate vision';
        throw new Error(message);
      }
    },
  });
};
